import { orderBy } from "@progress/kendo-data-query";
import { Grid, GridColumn, GridPageChangeEvent, GridRowClickEvent, GridSortChangeEvent } from "@progress/kendo-react-grid";
import {
    Menu,
    MenuItem,
    MenuItemLink,
    MenuSelectEvent,
} from "@progress/kendo-react-layout";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import {
    RadioButton,
    RadioButtonChangeEvent,
} from "@progress/kendo-react-inputs";
import React, { Fragment, useEffect, useState ,useRef} from "react";
import { useSelector } from "react-redux";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { getOptionsSelector } from "../Common/Slices/optionSlice";
import { getParamsSelector, updateParams } from "../Common/Slices/ParamSlice";
import { machineTimesToHours } from "../Common/Util_methods/format";
import { paramsById } from "../Common/Util_methods/scope";
import { useAppDispatch } from "../Core/store.hooks";
import { getDevicesSelector } from "../Devices/Slice";
import { filterBy } from "@progress/kendo-data-query";
import { Api } from "./Api";
import Format from "../Common/Util_methods/format";
import { RangeFilterCell } from "../Common/Components/GridRangeFilter";

interface GridWidgetProps {
    id: string;
    header: string;
    params:any
}

interface PageState {
    skip: number;
    take: number;
}


const MachineTimesGridWidget = (props: GridWidgetProps) => {
    const initialSort: any = [{
        field: "failureDuration",
        dir: "desc",
    },];

    const initialDataState: PageState = { skip: 0, take: 20 };

    const [page, setPage] = useState<PageState>(initialDataState);
    const [sort, setSort] = useState(initialSort);
    const [gridData, updateGridData] = useState([]);
    const [dataProcessed, setDataProcessed] = useState(false);
    const [errorMessage, updateErrorMessage] = useState(null);
    const [data, updateData] = useState(null);
    const [loadingData, updateLoadingData] = useState(false); const [filter, setFilter] = useState();
 
    const filterChange = (event: any) => {
        if (gridData != null) {
            updateData(filterBy(gridData, event.filter));
            setFilter(event.filter);
        }
    };

   
    const pageChange = (event: GridPageChangeEvent) => {
        setPage(event.page);
    };


    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        
        fetchData(props.params,signal);
        
        return () => controller.abort();

    }, [props.params])
  
    const _export = useRef<ExcelExport | null>(null);

    const excelExport = (event: MenuSelectEvent) => {
        if (event.item.text === "Export to Excel") {
            if (_export.current !== null) {
                _export.current.save();
            }
        }
    };

    function renderMenuIconIfApplicable(props: any) {
        return props.item.icon ? (
            <span
                style={{ fontSize: "16px" }}
                className={`k-icon k-i-${props.item.icon}`}
                role="presentation"
                key="0"
            />
        ) : null;
    }
    const linkRender = (props: any) => {
        return (
            <MenuItemLink url={props.item.url} opened={props.opened}>
                {[renderMenuIconIfApplicable(props), props.item.text, null]}
            </MenuItemLink>
        );
    };
    const fetchData = (params: any, signal: any) => {
        updateLoadingData(true);
        Api.fetchDescriptionStats(params, signal)
            .then((response: any) => {
                if (response != "canceled") {
                    updateData(response); updateGridData(response);
                }
                updateLoadingData(false);

            })
            .catch((error) => {
                updateLoadingData(false);

                if (error.message != "canceled") {
                    // setErrorMessage("Oops something went wrong, unable to get data.");
                }
                console.log(error);
            });
    }
    const dateCell = (props: any) => {
        return <td>{props.dataItem.time.split("T")[0]}</td>;
    };
    const valueCell = (props: any) => {
        return <td>{props.dataItem.cumulativeValue.toFixed(3)}</td>;
    };
    if (loadingData) return <Spinner text="data" />;
    if (errorMessage != null ) {
        return (
            <ErrorMessage
                text={"Oops something went wrong, unable to get data."}
                id={props.id}
                header={props.header}
            />
        );
    }
    if (gridData != null && gridData.length == 0) {
        return (
            <ErrorMessage
                text={"No data found for selected filters."}
                id={props.id}
                header={props.header}
            />
        );
    }
    if (gridData == null || gridData.length<1) {
        return (
            <div>No data found for selected filters</div>
            )
    }
    return (
        <div style={{ height: "100%", position: "relative" }}>
            <p>Note: Component wear out data collection to the cloud started on 10.10.2023. Data is not available for all devices and not available for any device prior 10.10.2023.</p> <br/>
            <span style={{ fontWeight: "bold" }}>Assembly: </span>{gridData[0].parentAssembly}<br />
            <span style={{ fontWeight: "bold" }}>Component: </span>{gridData[0].component}<br />
            <span style={{ fontWeight: "bold" }}>Header: </span>{gridData[0].description} <br />
            <span style={{ fontWeight: "bold" }}>Unit: </span>{gridData[0].unit}<br />
          
                <div style={{
                    position: "absolute",
                    top: "-20px",
                    left: "-20px"
                }}>
                    <Menu
                        openOnClick={true}
                        onSelect={excelExport}
                        linkRender={linkRender}
                    >
                        <MenuItem
                            text=""
                            icon="more-horizontal"
                            data={{}}
                            cssStyle={{ color: "black" }}
                        >
                            <MenuItem text="Export to Excel" />
                        </MenuItem>
                    </Menu>
                </div>
                <ExcelExport data={data} ref={_export}>
            <Grid
                data={orderBy(data, sort).slice(page.skip, page.take + page.skip)}
                sortable={true}
                sort={sort}
                onSortChange={(e: GridSortChangeEvent) => {
                    setSort(e.sort);
                }}
                columnVirtualization={true}
                pageSize={20}
                scrollable={"virtual"}
               // pageable={true}
                onPageChange={pageChange}
                skip={page.skip}
                take={page.take}
                total={data.length}
               // onRowClick={(event: GridRowClickEvent) => handleRowClick(event.dataItem.id)}
                style={{ fontSize: "13px", height: " calc( 100% - 100px  )" }}
                    resizable={true}
                    filterable={true}
                    filter={filter}
                    onFilterChange={filterChange}
                
            >
                <GridColumn field="customerName" title="Customer" width="230px" />
                <GridColumn field="deviceName" title="Device" width="230px" />
                    <GridColumn field="cumulativeValue" title="Cumulative Value" width="450px" filter="numeric" cell={valueCell} filterCell={RangeFilterCell} />
                    <GridColumn field="time" title="Data collection start date" width="230px" cell={dateCell } />
             
                    </Grid> </ExcelExport>
        </div>
    )
}

export default MachineTimesGridWidget;